import { render } from "./Scorecard.vue?vue&type=template&id=6a9f4dd9"
import script from "./Scorecard.vue?vue&type=script&lang=js"
export * from "./Scorecard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/Scorecard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a9f4dd9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a9f4dd9', __exports__)) {
    api.reload('6a9f4dd9', __exports__)
  }
  
  module.hot.accept("./Scorecard.vue?vue&type=template&id=6a9f4dd9", () => {
    api.rerender('6a9f4dd9', render)
  })

}


export default __exports__